<template>
    <q-modal v-model="visible" content-css="width: 800px;">
        <div class="q-pa-lg">
            <form autocomplete="off" @submit.prevent="saveProvider">
                <q-field>
                    <q-input stack-label="Название поставщика (для внешнего использование)" type="text"
                             v-model="provider.name"
                             :error="$v.provider.name.$error"/>
                </q-field>
                <q-field>
                    <q-input stack-label="Название поставщика (алиас для внутреннего использования)" type="text"
                             v-model="provider.alias"/>
                </q-field>
                <q-field>
                    <q-input stack-label="Ставка НДС (%)" type="number" v-model="provider.vat_rate"/>
                </q-field>
            </form>
            <div class="q-mt-lg row justify-end items-center">
                <div>
                    <q-btn @click="saveProvider()" label="Сохранить" color="primary"/>
                    <q-btn @click="visible = false" color="primary" flat label="Отмена"/>
                </div>
            </div>
        </div>
    </q-modal>
</template>

<script>
import _ from 'lodash'

import { required } from 'vuelidate/lib/validators'

import { QBtn, QField, QInput, QModal, QToggle } from 'quasar'

import api from 'mixins/api'

export default {
    name: 'ServiceProviderCreate',
    components: {
        QField,
        QInput,
        QBtn,
        QModal,
        QToggle,
    },
    mixins: [
        api,
    ],
    props: {
        value: Boolean,
        provider: {
            type: Object,
            default () {
                return {
                    name: '',
                    alias: '',
                    vat_rate: 0,
                }
            },
        },
    },
    computed: {
        visible: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            },
        },
    },
    validations: {
        provider: {
            name: { required },
        },
    },
    methods: {
        saveProvider () {
            this.$v.provider.$touch()
            if (this.$v.provider.$error) {
                this.$q.notify('Please review fields again.')
                return
            }

            this.visible = false
            this.$http.post(`/api/v1.0/service-providers`, this.provider).then(response => {
                this.$q.notify({
                    message: 'Сохранено',
                    type: 'positive',
                })
                this.$emit('save')
            }).catch(error => {
                _.forOwn(error.response.data.errors, (value, key) => {
                    this.$q.notify({ message: value[0], type: 'negative' })
                })
            })
        },
    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ServiceProviderCreate/ServiceProviderCreate.vue